"use client";

/**
 * Shown through <ClerkFailed> when clerk-js cannot load (a content blocker, a
 * captive portal, no signal). Before, that left /signup and /login blank with
 * no way forward. Sign-up also offers the job-pack funnel, which needs no
 * account to start.
 */
export function AuthFormUnavailable({ flow }: { flow: "sign-up" | "sign-in" }) {
  return (
    <div
      role="alert"
      className="w-[25rem] max-w-[calc(100vw-2rem)] rounded-xl border border-border bg-surface px-8 py-7 text-center shadow-md"
    >
      <h1 className="text-[17px] font-bold text-foreground">
        {flow === "sign-up"
          ? "The sign-up form didn't load"
          : "The log-in form didn't load"}
      </h1>
      <p className="mt-2 text-sm text-text-secondary">
        This is usually a weak signal or a browser extension that blocks
        scripts. Check your connection and try again.
      </p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="mt-5 w-full rounded-lg bg-accent px-4 py-2.5 text-sm font-semibold text-white hover:bg-accent-dark"
      >
        Try again
      </button>
      {flow === "sign-up" && (
        <a
          href="/start-project"
          className="mt-3 inline-block text-sm font-medium text-accent-dark underline"
        >
          Or start your first job now, no account needed yet
        </a>
      )}
    </div>
  );
}
